import React, { useState } from 'react';
import config from '../config';
import { KB_ABOUT_CHANGE } from '../constants/kbLinks';

const FMH_LOGO = '/assets/images/followmyhealth.svg';
const RETIREMENT_DATE = 'Monday, December 7';

const RetirementBanner = () => {
    // Keep hooks above the config check so the hook count is the same either way.
    const [isExpanded, setIsExpanded] = useState(true);

    // Shares the login page's pre-retirement flag: the two banners announce the same
    //   closure, so they are turned on and off together.
    if (!config.showLoginPreRetirementBanner) {
        return null;
    }

    const bannerClass = isExpanded
        ? 'retirement-banner'
        : 'retirement-banner retirement-banner--collapsed';
    const toggleClass = isExpanded
        ? 'btn--link retirement-banner__toggle'
        : 'btn--link retirement-banner__toggle retirement-banner__toggle--collapsed';

    return (
        <div className={bannerClass}>
            {isExpanded ? (
                <div className="retirement-banner__content">
                    <p className="retirement-banner__body">
                        <b>Patient Fusion closes {RETIREMENT_DATE}.</b> After that, this app can no longer
                        use your Patient Fusion sign in to get your records. Reach out to this app's support
                        team and ask them to update their connection. Your provider can also tell you how to
                        see your records. Most providers are moving to
                        {/* No space around the logo: its 4px horizontal margins provide the gap. */}
                        <img className="retirement-banner__logo" src={FMH_LOGO} alt="" />
                        FollowMyHealth. It is an easier way to see everything in one place.
                    </p>
                    <a
                        className="btn--link retirement-banner__read-more"
                        href={KB_ABOUT_CHANGE}
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        Read more about this change
                    </a>
                </div>
            ) : (
                <b className="retirement-banner__summary">Patient Fusion closes {RETIREMENT_DATE}</b>
            )}
            <button
                aria-expanded={isExpanded}
                className={toggleClass}
                onClick={() => setIsExpanded(!isExpanded)}
                type="button"
            >
                {isExpanded ? 'Hide' : 'Expand'}
                <span aria-hidden="true">{isExpanded ? ' ▲' : ' ▼'}</span>
            </button>
        </div>
    );
};

export default RetirementBanner;
